/**
 * Routes_DE - All configured internal routes in German
 */
export const Routes_DE = {
  ROOT: '/',
  EMPTY: '#',
  ERROR: '/404',
  ACCOUNT: {
    ADDRESS_BOOK: '/mein-adressbuch',
    CONFIRM: '/account/confirm',
    FAVORITES: '/account/favorites',
    GARAGE: '/meine-garage',
    GARAGE_ADD: '/meine-garage/fahrzeugdetails',
    LOGIN: '/login',
    ORDERS: '/meine-bestellungen',
    PASSWORD: '/passwort-vergessen',
    PASSWORD_RESET: '/passwort-neu',
    PROFILE: '/meine-daten',
    REGISTER: '/registrierung',
  },
  CARS: {
    ALL: '/auto-kaufen',
    NEW: '/auto-kaufen/neuwagen',
    USED: '/auto-kaufen/gebrauchtwagen',
    ELECTRIC: '/auto-kaufen/elektroauto',
    SUV: '/auto-kaufen/suv',
    HYBRID: '/auto-kaufen/hybrid-auto',
    SMALLCAR: '/auto-kaufen/kleinwagen',
    VAN: '/auto-kaufen/van',
    DAY_REGISTRATION: '/auto-kaufen/tageszulassung',
  },
  PCP_ACCESSORIES: '/zubehoer-kaufen',
  TRADE_IN_WIDGET: '/trade-in-widget',
  PDP_ACCESSORIES: '/zubehoerteil',
  PDP_VEHICLES: '/autos',
  CHECKOUT: '/checkout/zusaetzliche-services',
  CHECKOUT_STEPS: {
    BILLING: '/checkout/rechnungsadresse',
    CONFIRMATION: '/checkout/zusammenfassung',
    DELIVERY: '/checkout/lieferung',
    PAYMENT: '/checkout/bezahlmethoden',
  },
  WORKSHOP_SERVICES: '/werkstatt-services',
  SERVICE_BOOKING: '/werkstatt-services/fahrzeugdetails',
  SERVICE_BOOKING_MAILING_SUCCESS: '/services/mailing/erfolgreich',
  SERVICE_BOOKING_STEPS: {
    APPOINTMENT: '/werkstatt-services/termin-waehlen',
    WORKSHOP: '/werkstatt-services/werkstatt-finden',
    CONTACT: '/werkstatt-services/anfrage',
    SUMMARY: '/werkstatt-services/zusammenfassung',
    CONFIRMATION: '/werkstatt-services/bestaetigung',
  },
  BANKING_REQUEST: '/bankantrag/persoenliche-angaben',
  BANKING_REQUEST_STEPS: {
    HOUSEHOLD_WORK: '/bankantrag/haushalt-beruf',
    INCOME_EXPENSES: '/bankantrag/einkommen-ausgaben',
    INCOME_DETAILS: '/bankantrag/einkommensnachweise',
    CONFIRMATION: '/bankantrag/bestaetigung',
    BANKING_PROCESS: '/bankantrag',
  },
  SHOPPING_CART: '/warenkorb',
  TRADE_IN: '/auto-verkaufen/fahrzeugdetails',
  TRADE_IN_PRICE_OFFER: '/auto-verkaufen/preis-angebot',
  TRADE_IN_STEPS: {
    EQUIP_COND: '/auto-verkaufen/ausstattung-zustand',
    DEALER: '/auto-verkaufen/haendlersuche',
    OFFER: '/auto-verkaufen/preisschaetzung',
  },
  C2C: '/auto-verkaufen-privat/informationen-zum-auto',
  C2C_STEPS: {
    IMAGES: '/auto-verkaufen-privat/bilder',
    CONFIRMATION: '/auto-verkaufen-privat/bestaetigung',
  },
  NEWSLETTER: {
    SUBSCRIBE_SUCCESSFUL: '/newsletter/anmeldung/erfolgreich',
    SUBSCRIBE_FAILED: '/newsletter/anmeldung/fehlgeschlagen',
    UNSUBSCRIBE_SUCCESSFUL: '/newsletter/abmeldung/erfolgreich',
    UNSUBSCRIBE_FAILED: '/newsletter/abmeldung/fehlgeschlagen',
  },
  GARAGE_YT_CONTENT: '/garage-yt',
  CAR_PARTS: '/autoteile',
  BANKING_REQUEST_OLD: '/banking-request/',
  FAVORITES: '/favoriten',
  ONLINE_GARAGE: '/pages/online-garage',
  COMPARE: '/vergleichen',
} as const;

/**
 * Routes_EN - All configured internal routes in English
 */
export const Routes_EN = {
  ROOT: '/',
  EMPTY: '#',
  ERROR: '/404',
  ACCOUNT: {
    ADDRESS_BOOK: '/account/address-book',
    CONFIRM: '/account/confirm',
    FAVORITES: '/account/favorites',
    GARAGE: '/account/garage',
    GARAGE_ADD: '/account/garage/add',
    LOGIN: '/account/login',
    ORDERS: '/account/orders',
    PASSWORD: '/account/password',
    PASSWORD_RESET: '/account/password/reset',
    PROFILE: '/account/profile',
    REGISTER: '/account/register',
  },
  CARS: {
    ALL: '/cars',
    NEW: '/cars/new',
    USED: '/cars/used',
    ELECTRIC: '/cars/electric',
    SUV: '/cars/suv',
    HYBRID: '/cars/hybrid',
    SMALLCAR: '/cars/smallcar',
    VAN: '/cars/van',
    DAY_REGISTRATION: '/cars/day-registration',
  },
  PCP_ACCESSORIES: '/accessories-shop',
  TRADE_IN_WIDGET: '/trade-in-widget',
  PDP_ACCESSORIES: '/accessories',
  PDP_VEHICLES: '/vehicles',
  CHECKOUT: '/checkout',
  CHECKOUT_STEPS: {
    BILLING: '/checkout/billing',
    CONFIRMATION: '/checkout/confirmation',
    DELIVERY: '/checkout/delivery',
    PAYMENT: '/checkout/payment',
    SERVICES: '/checkout/services',
  },
  CAR_PARTS: '/car-parts',
  CAR_ACCESSORIES: '/car-accessories',
  HOW_TO_ACCESSORIES: '/car-accessories/how-to',
  WORKSHOP_SERVICES: '/workshop-services',
  SERVICE_BOOKING: '/service-booking',
  SERVICE_BOOKING_MAILING_SUCCESS: '/services/mailing/success',
  SERVICE_BOOKING_STEPS: {
    APPOINTMENT: '/service-booking/appointment',
    WORKSHOP: '/service-booking/workshop',
    CONTACT: '/service-booking/contact',
    SUMMARY: '/service-booking/summary',
    CONFIRMATION: '/service-booking/confirmation',
  },
  BANKING_REQUEST: '/banking-request',
  BANKING_REQUEST_STEPS: {
    HOUSEHOLD_WORK: '/banking-request/household-profession',
    INCOME_EXPENSES: '/banking-request/expenses-income',
    INCOME_DETAILS: '/banking-request/additional-documents',
    CONFIRMATION: '/banking-request/confirmation',
    BANKING_PROCESS: '/banking-request',
  },
  SHOPPING_CART: '/shoppingCart',
  TRADE_IN: '/tradein/flow',
  TRADE_IN_PRICE_OFFER: '/tradein/price-offer',
  TRADE_IN_STEPS: {
    EQUIP_COND: '/tradein/flow/condition',
    DEALER: '/tradein/flow/dealer',
    OFFER: '/tradein/flow/offer',
  },
  C2C: '/private-sale',
  C2C_STEPS: {
    IMAGES: '/private-sale/upload-images',
    CONFIRMATION: '/private-sale/confirmation',
  },
  NEWSLETTER: {
    SUBSCRIBE_SUCCESSFUL: '/newsletter/subscribe/successful',
    SUBSCRIBE_FAILED: '/newsletter/subscribe/failed',
    UNSUBSCRIBE_SUCCESSFUL: '/newsletter/unsubscribe/successful',
    UNSUBSCRIBE_FAILED: '/newsletter/unsubscribe/failed',
  },
  GARAGE_YT_CONTENT: '/garage-yt',
  TRADE_IN_WIDGET_STORYBLOK: '/webcomponents/tradeinwidget/',
  BANKING_REQUEST_OLD: 'banking-request',
  COMPARE: '/compare',
  ONLINE_GARAGE: '/pages/online-garage',
  FAVORITES: '/favorites',
} as const;

export const routeLocales = ['de', 'en'] as const;

export type RouteLocale = (typeof routeLocales)[number];

export type RouteName =
  | 'ROOT'
  | 'CARS_ALL'
  | 'CARS_NEW'
  | 'CARS_USED'
  | 'CARS_VAN'
  | 'CARS_SMALLCAR'
  | 'CARS_HYBRID'
  | 'CARS_ELECTRIC'
  | 'CARS_SUV'
  | 'CARS_DAY_REGISTRATION'
  | 'ACCOUNT_LOGIN'
  | 'WORKSHOP_SERVICES'
  | 'SERVICE_BOOKING_MAILING_SUCCESS'
  | 'SERVICE_BOOKING_STEPS_VEHICLE_DETAILS'
  | 'SERVICE_BOOKING_STEPS_WORKSHOP'
  | 'SERVICE_BOOKING_STEPS_APPOINTMENT'
  | 'SERVICE_BOOKING_STEPS_CONTACT'
  | 'SERVICE_BOOKING_STEPS_SUMMARY'
  | 'SERVICE_BOOKING_STEPS_CONFIRMATION'
  | 'NEWSLETTER_SUBSCRIBE_SUCCESSFUL'
  | 'NEWSLETTER_SUBSCRIBE_FAILED'
  | 'NEWSLETTER_UNSUBSCRIBE_SUCCESSFUL'
  | 'NEWSLETTER_UNSUBSCRIBE_FAILED'
  | 'ACCOUNT_ADDRESS_BOOK'
  | 'ACCOUNT_CONFIRM'
  | 'ACCOUNT_FAVORITES'
  | 'ACCOUNT_GARAGE'
  | 'ACCOUNT_ORDERS'
  | 'ACCOUNT_PASSWORD'
  | 'ACCOUNT_PASSWORD_RESET'
  | 'ACCOUNT_PROFILE'
  | 'ACCOUNT_REGISTER'
  | 'SHOPPING_CART'
  | 'TRADE_IN_PRICE_OFFER'
  | 'TRADE_IN_VEHICLE_DETAILS'
  | 'TRADE_IN_EQUIP_COND'
  | 'TRADE_IN_DEALER'
  | 'TRADE_IN_OFFER'
  | 'C2C'
  | 'C2C_IMAGES'
  | 'C2C_CONFIRMATION'
  | 'GARAGE_YT_CONTENT'
  | 'PCP_ACCESSORIES'
  | 'TRADE_IN_WIDGET'
  | 'PDP_ACCESSORIES'
  | 'PDP_VEHICLES'
  | 'CHECKOUT'
  | 'CHECKOUT_BILLING'
  | 'CHECKOUT_PAYMENT'
  | 'CHECKOUT_DELIVERY'
  | 'CHECKOUT_CONFIRMATION'
  | 'BANKING_REQUEST_PERSONAL'
  | 'BANKING_REQUEST_HOUSEHOLD'
  | 'BANKING_REQUEST_INCOME_EXPENSES'
  | 'BANKING_REQUEST_INCOME_DETAILS'
  | 'BANKING_REQUEST_CONFIRMATION'
  | 'BANKING_REQUEST_PROCESS'
  | 'GARAGE_ADD'
  | 'WHITELABEL_WIDGET_CONFIGURATOR'
  | 'WHITELABEL_WIDGET_IFRAME'
  | 'COMPARE'
  | 'BANKING_REQUEST_OLD'
  | 'ONLINE_GARAGE'
  | 'FAVORITES';

export type RouteRule =
  | {
      action: 'redirect';
      target: RouteName;
    }
  | {
      action: 'loginThenRedirect';
      target: RouteName;
    };

export type Route = {
  paths: Record<RouteLocale, string>;
  hasDealerParam?: boolean; // `true` if page is implemented in the [dealer] directory
  hasSlug?: boolean; // `true` if page needs/supports a slug
  isOld?: boolean; // 'true' if it old link taht needs a fix
  rules?: {
    ifAuthenticated?: RouteRule;
    ifNotAuthenticated?: RouteRule;
    ifIsOld?: RouteRule;
  };
};

/**
 * ROUTES - all flat map of all routes, with flags and the path for each locale
 * IMPORTANT: used by next.config for url rewrites -> KEEP IT FLAT
 */
export const ROUTES: Record<RouteName, Route> = {
  ROOT: {
    paths: {
      de: Routes_DE.ROOT,
      en: Routes_EN.ROOT,
    },
    hasDealerParam: true,
  },
  CARS_ALL: {
    paths: {
      de: Routes_DE.CARS.ALL,
      en: Routes_EN.CARS.ALL,
    },
    hasDealerParam: true,
    hasSlug: true,
  },
  CARS_NEW: {
    paths: {
      de: Routes_DE.CARS.NEW,
      en: Routes_EN.CARS.NEW,
    },
    hasDealerParam: true,
  },
  CARS_USED: {
    paths: {
      de: Routes_DE.CARS.USED,
      en: Routes_EN.CARS.USED,
    },
    hasDealerParam: true,
  },
  CARS_VAN: {
    paths: {
      de: Routes_DE.CARS.VAN,
      en: Routes_EN.CARS.VAN,
    },
    hasDealerParam: true,
  },
  CARS_SMALLCAR: {
    paths: {
      de: Routes_DE.CARS.SMALLCAR,
      en: Routes_EN.CARS.SMALLCAR,
    },
    hasDealerParam: true,
  },
  CARS_HYBRID: {
    paths: {
      de: Routes_DE.CARS.HYBRID,
      en: Routes_EN.CARS.HYBRID,
    },
    hasDealerParam: true,
  },
  CARS_ELECTRIC: {
    paths: {
      de: Routes_DE.CARS.ELECTRIC,
      en: Routes_EN.CARS.ELECTRIC,
    },
    hasDealerParam: true,
  },
  CARS_SUV: {
    paths: {
      de: Routes_DE.CARS.SUV,
      en: Routes_EN.CARS.SUV,
    },
    hasDealerParam: true,
  },
  CARS_DAY_REGISTRATION: {
    paths: {
      de: Routes_DE.CARS.DAY_REGISTRATION,
      en: Routes_EN.CARS.DAY_REGISTRATION,
    },
    hasDealerParam: true,
  },
  ACCOUNT_LOGIN: {
    paths: {
      de: Routes_DE.ACCOUNT.LOGIN,
      en: Routes_EN.ACCOUNT.LOGIN,
    },
    rules: {
      ifAuthenticated: {
        action: 'redirect',
        target: 'ACCOUNT_GARAGE',
      },
    },
  },
  WORKSHOP_SERVICES: {
    paths: {
      de: Routes_DE.WORKSHOP_SERVICES,
      en: Routes_EN.WORKSHOP_SERVICES,
    },
    hasDealerParam: true,
  },
  SERVICE_BOOKING_MAILING_SUCCESS: {
    paths: {
      de: Routes_DE.SERVICE_BOOKING_MAILING_SUCCESS,
      en: Routes_EN.SERVICE_BOOKING_MAILING_SUCCESS,
    },
  },
  SERVICE_BOOKING_STEPS_VEHICLE_DETAILS: {
    paths: {
      de: Routes_DE.SERVICE_BOOKING,
      en: Routes_EN.SERVICE_BOOKING,
    },
  },
  SERVICE_BOOKING_STEPS_WORKSHOP: {
    paths: {
      de: Routes_DE.SERVICE_BOOKING_STEPS.WORKSHOP,
      en: Routes_EN.SERVICE_BOOKING_STEPS.WORKSHOP,
    },
  },
  SERVICE_BOOKING_STEPS_APPOINTMENT: {
    paths: {
      de: Routes_DE.SERVICE_BOOKING_STEPS.APPOINTMENT,
      en: Routes_EN.SERVICE_BOOKING_STEPS.APPOINTMENT,
    },
  },
  SERVICE_BOOKING_STEPS_SUMMARY: {
    paths: {
      de: Routes_DE.SERVICE_BOOKING_STEPS.SUMMARY,
      en: Routes_EN.SERVICE_BOOKING_STEPS.SUMMARY,
    },
  },
  SERVICE_BOOKING_STEPS_CONTACT: {
    paths: {
      de: Routes_DE.SERVICE_BOOKING_STEPS.CONTACT,
      en: Routes_EN.SERVICE_BOOKING_STEPS.CONTACT,
    },
  },
  SERVICE_BOOKING_STEPS_CONFIRMATION: {
    paths: {
      de: Routes_DE.SERVICE_BOOKING_STEPS.CONFIRMATION,
      en: Routes_EN.SERVICE_BOOKING_STEPS.CONFIRMATION,
    },
  },
  NEWSLETTER_SUBSCRIBE_SUCCESSFUL: {
    paths: {
      de: Routes_DE.NEWSLETTER.SUBSCRIBE_SUCCESSFUL,
      en: Routes_EN.NEWSLETTER.SUBSCRIBE_SUCCESSFUL,
    },
  },
  NEWSLETTER_SUBSCRIBE_FAILED: {
    paths: {
      de: Routes_DE.NEWSLETTER.SUBSCRIBE_FAILED,
      en: Routes_EN.NEWSLETTER.SUBSCRIBE_FAILED,
    },
  },
  NEWSLETTER_UNSUBSCRIBE_SUCCESSFUL: {
    paths: {
      de: Routes_DE.NEWSLETTER.UNSUBSCRIBE_SUCCESSFUL,
      en: Routes_EN.NEWSLETTER.UNSUBSCRIBE_SUCCESSFUL,
    },
  },
  NEWSLETTER_UNSUBSCRIBE_FAILED: {
    paths: {
      de: Routes_DE.NEWSLETTER.UNSUBSCRIBE_FAILED,
      en: Routes_EN.NEWSLETTER.UNSUBSCRIBE_FAILED,
    },
  },
  ACCOUNT_ADDRESS_BOOK: {
    paths: {
      de: Routes_DE.ACCOUNT.ADDRESS_BOOK,
      en: Routes_EN.ACCOUNT.ADDRESS_BOOK,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'ACCOUNT_ADDRESS_BOOK',
      },
    },
  },
  ACCOUNT_CONFIRM: {
    paths: {
      de: Routes_DE.ACCOUNT.CONFIRM,
      en: Routes_EN.ACCOUNT.CONFIRM,
    },
  },
  ACCOUNT_FAVORITES: {
    paths: {
      de: Routes_DE.ACCOUNT.FAVORITES,
      en: Routes_EN.ACCOUNT.FAVORITES,
    },
  },
  ACCOUNT_GARAGE: {
    paths: {
      de: Routes_DE.ACCOUNT.GARAGE,
      en: Routes_EN.ACCOUNT.GARAGE,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'ACCOUNT_GARAGE',
      },
    },
  },
  ACCOUNT_ORDERS: {
    paths: {
      de: Routes_DE.ACCOUNT.ORDERS,
      en: Routes_EN.ACCOUNT.ORDERS,
    },
    hasSlug: true,
    rules: {
      ifNotAuthenticated: {
        action: 'redirect',
        target: 'ROOT',
      },
    },
  },
  ACCOUNT_PASSWORD: {
    paths: {
      de: Routes_DE.ACCOUNT.PASSWORD,
      en: Routes_EN.ACCOUNT.PASSWORD,
    },
    hasSlug: true,
  },
  ACCOUNT_PASSWORD_RESET: {
    paths: {
      de: Routes_DE.ACCOUNT.PASSWORD_RESET,
      en: Routes_EN.ACCOUNT.PASSWORD_RESET,
    },
  },
  ACCOUNT_PROFILE: {
    paths: {
      de: Routes_DE.ACCOUNT.PROFILE,
      en: Routes_EN.ACCOUNT.PROFILE,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'redirect',
        target: 'ROOT',
      },
    },
  },
  ACCOUNT_REGISTER: {
    paths: {
      de: Routes_DE.ACCOUNT.REGISTER,
      en: Routes_EN.ACCOUNT.REGISTER,
    },
  },
  SHOPPING_CART: {
    paths: {
      de: Routes_DE.SHOPPING_CART,
      en: Routes_EN.SHOPPING_CART,
    },
  },
  TRADE_IN_PRICE_OFFER: {
    paths: {
      de: Routes_DE.TRADE_IN_PRICE_OFFER,
      en: Routes_EN.TRADE_IN_PRICE_OFFER,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'TRADE_IN_VEHICLE_DETAILS',
      },
    },
  },
  TRADE_IN_VEHICLE_DETAILS: {
    paths: {
      de: Routes_DE.TRADE_IN,
      en: Routes_EN.TRADE_IN,
    },
  },
  TRADE_IN_EQUIP_COND: {
    paths: {
      de: Routes_DE.TRADE_IN_STEPS.EQUIP_COND,
      en: Routes_EN.TRADE_IN_STEPS.EQUIP_COND,
    },
  },
  TRADE_IN_DEALER: {
    paths: {
      de: Routes_DE.TRADE_IN_STEPS.DEALER,
      en: Routes_EN.TRADE_IN_STEPS.DEALER,
    },
  },
  TRADE_IN_OFFER: {
    paths: {
      de: Routes_DE.TRADE_IN_STEPS.OFFER,
      en: Routes_EN.TRADE_IN_STEPS.OFFER,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'TRADE_IN_VEHICLE_DETAILS',
      },
    },
  },
  C2C: {
    paths: {
      de: Routes_DE.C2C,
      en: Routes_EN.C2C,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'redirect',
        target: 'ROOT',
      },
    },
    hasDealerParam: true,
  },
  C2C_IMAGES: {
    paths: {
      de: Routes_DE.C2C_STEPS.IMAGES,
      en: Routes_EN.C2C_STEPS.IMAGES,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'redirect',
        target: 'ROOT',
      },
    },
    hasDealerParam: true,
  },
  C2C_CONFIRMATION: {
    paths: {
      de: Routes_DE.C2C_STEPS.CONFIRMATION,
      en: Routes_EN.C2C_STEPS.CONFIRMATION,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'redirect',
        target: 'ROOT',
      },
    },
    hasDealerParam: true,
  },
  GARAGE_YT_CONTENT: {
    paths: {
      de: Routes_DE.GARAGE_YT_CONTENT,
      en: Routes_EN.GARAGE_YT_CONTENT,
    },
    hasDealerParam: true,
  },
  PCP_ACCESSORIES: {
    paths: {
      de: Routes_DE.PCP_ACCESSORIES,
      en: Routes_EN.PCP_ACCESSORIES,
    },
  },
  TRADE_IN_WIDGET: {
    paths: {
      de: Routes_DE.TRADE_IN_WIDGET,
      en: Routes_EN.TRADE_IN_WIDGET,
    },
  },
  PDP_ACCESSORIES: {
    paths: {
      de: Routes_DE.PDP_ACCESSORIES,
      en: Routes_EN.PDP_ACCESSORIES,
    },
    hasSlug: true,
  },
  COMPARE: {
    paths: {
      de: Routes_DE.COMPARE,
      en: Routes_EN.COMPARE,
    },
    hasDealerParam: true,
  },
  PDP_VEHICLES: {
    paths: {
      de: Routes_DE.PDP_VEHICLES,
      en: Routes_EN.PDP_VEHICLES,
    },
    hasDealerParam: true,
    hasSlug: true,
  },
  CHECKOUT: {
    paths: {
      de: Routes_DE.CHECKOUT,
      en: Routes_EN.CHECKOUT,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'CHECKOUT',
      },
    },
  },
  CHECKOUT_BILLING: {
    paths: {
      de: Routes_DE.CHECKOUT_STEPS.BILLING,
      en: Routes_EN.CHECKOUT_STEPS.BILLING,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'CHECKOUT',
      },
    },
  },
  CHECKOUT_PAYMENT: {
    paths: {
      de: Routes_DE.CHECKOUT_STEPS.PAYMENT,
      en: Routes_EN.CHECKOUT_STEPS.PAYMENT,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'CHECKOUT',
      },
    },
  },
  CHECKOUT_DELIVERY: {
    paths: {
      de: Routes_DE.CHECKOUT_STEPS.DELIVERY,
      en: Routes_EN.CHECKOUT_STEPS.DELIVERY,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'CHECKOUT',
      },
    },
  },
  CHECKOUT_CONFIRMATION: {
    paths: {
      de: Routes_DE.CHECKOUT_STEPS.CONFIRMATION,
      en: Routes_EN.CHECKOUT_STEPS.CONFIRMATION,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'redirect',
        target: 'ONLINE_GARAGE',
      },
    },
  },
  BANKING_REQUEST_PERSONAL: {
    paths: {
      de: Routes_DE.BANKING_REQUEST,
      en: Routes_EN.BANKING_REQUEST,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'ACCOUNT_ORDERS',
      },
    },
    hasSlug: true,
  },
  BANKING_REQUEST_HOUSEHOLD: {
    paths: {
      de: Routes_DE.BANKING_REQUEST_STEPS.HOUSEHOLD_WORK,
      en: Routes_EN.BANKING_REQUEST_STEPS.HOUSEHOLD_WORK,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'ACCOUNT_ORDERS',
      },
    },
    hasSlug: true,
  },
  BANKING_REQUEST_INCOME_EXPENSES: {
    paths: {
      de: Routes_DE.BANKING_REQUEST_STEPS.INCOME_EXPENSES,
      en: Routes_EN.BANKING_REQUEST_STEPS.INCOME_EXPENSES,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'ACCOUNT_ORDERS',
      },
    },
    hasSlug: true,
  },
  BANKING_REQUEST_INCOME_DETAILS: {
    paths: {
      de: Routes_DE.BANKING_REQUEST_STEPS.INCOME_DETAILS,
      en: Routes_EN.BANKING_REQUEST_STEPS.INCOME_DETAILS,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'ACCOUNT_ORDERS',
      },
    },
    hasSlug: true,
  },
  BANKING_REQUEST_CONFIRMATION: {
    paths: {
      de: Routes_DE.BANKING_REQUEST_STEPS.CONFIRMATION,
      en: Routes_EN.BANKING_REQUEST_STEPS.CONFIRMATION,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'ACCOUNT_ORDERS',
      },
    },
    hasSlug: true,
  },
  BANKING_REQUEST_PROCESS: {
    paths: {
      de: Routes_DE.BANKING_REQUEST_STEPS.BANKING_PROCESS,
      en: Routes_EN.BANKING_REQUEST_STEPS.BANKING_PROCESS,
    },
  },
  GARAGE_ADD: {
    paths: {
      de: Routes_DE.ACCOUNT.GARAGE_ADD,
      en: Routes_EN.ACCOUNT.GARAGE_ADD,
    },
    rules: {
      ifNotAuthenticated: {
        action: 'loginThenRedirect',
        target: 'GARAGE_ADD',
      },
    },
  },
  WHITELABEL_WIDGET_CONFIGURATOR: {
    paths: {
      de: '/whitelabel/widget-configurator',
      en: '/whitelabel/widget-configurator',
    },
    hasDealerParam: true,
  },
  WHITELABEL_WIDGET_IFRAME: {
    paths: {
      de: '/whitelabel/widget-iframe',
      en: '/whitelabel/widget-iframe',
    },
    hasDealerParam: true,
  },
  BANKING_REQUEST_OLD: {
    paths: {
      de: Routes_DE.BANKING_REQUEST_OLD,
      en: Routes_EN.BANKING_REQUEST_OLD,
    },
    isOld: true,
    rules: {
      ifIsOld: {
        action: 'redirect',
        target: 'BANKING_REQUEST_PERSONAL',
      },
    },
  },
  FAVORITES: {
    paths: {
      de: Routes_DE.FAVORITES,
      en: Routes_EN.FAVORITES,
    },
  },
  ONLINE_GARAGE: {
    paths: {
      de: Routes_DE.ONLINE_GARAGE,
      en: Routes_EN.ONLINE_GARAGE,
    },
  },
} as const;
